{
  "header": "Registrer skogeier",
  "headerOrganization": "Registrer skogeier - Organisasjon",
  "headerPrivate": "Registrer skogeier - Privat skogeier",
  "headerSameie": "Registrer skogeier - Sameie",
  "stepper": {
    "step1": "Skogeierprofil",
    "step2": "Leverandørnummer",
    "step3": "Eiendommer",
    "step4": "Oppsummering"
  },
  "representant": {
    "title": "Representant",
    "description": "Fyll inn hvem som skal være representant og kontaktes på vegne av skogeieren"
  },
  "mailRecipient": {
    "title": "Hvem skal motta posten?",
    "description": "Velg hvem som skal stå som mottaker.",
    "forestOwner": "Skogeier",
    "forestOwnerPrivate": "Skogeier",
    "forestOwnerSameie": "Sameie",
    "forestOwnerOrganization": "Organisasjon",
    "representative": "Representant",
    "organization": "Organisasjon",
    "other": "Annen",
    "otherNameLabel": "Navn",
    "otherNameDescription": "Fyll inn navnet på mottakeren",
    "isAddressOwnerLabel": "Mottaker er ikke innehaver av adressen",
    "isAddressOwnerDescription": "Velg dette hvis posten skal sendes via en annen person eller en organisasjon (C/O)",
    "addressOwnerNameLabel": "Navn på innehaver av adressen (C/O)",
    "addressOwnerNameDescription": "Fyll inn navnet på innehaveren av adressen"
  },
  "fields": {
    "forestOwnerTypeLabel": "Hvem eier skogen?",
    "forestSharesLabel": "Ønsker skogeier å bli andelseier?"
  },
  "step0": {
    "title": "Hvem vil du registrere?",
    "description": "Velg hvilken type skogeier du ønsker å registrere",
    "buttonStartRegistering": "Start registrering",
    "fieldForestSharesDescription": "Skogeier ønsker mer informasjon på senere tidspunkt, Viken Skog følger opp",
    "fieldForestSharesOptionYes": "Ja, andelseier",
    "fieldForestSharesOptionYesDescription": "Skogeier ønsker å bli andelseier i Viken Skog",
    "fieldForestSharesOptionNo": "Nei, ikke andelseier",
    "fieldForestSharesOptionNoDescription": "Skogeier ønsker ikke å bli andelseier",
    "fieldForestSharesOptionUncertain": "Usikker, ønsker mer informasjon",
    "fieldForestSharesOptionUncertainDescription": "Viken Skog tar kontakt for mer informasjon senere",
    "fieldForestOwnerTypeOrganization": "Organisasjon",
    "fieldForestOwnerTypePrivate": "Privat skogeier",
    "fieldForestOwnerTypeSameie": "Sameie",
    "fieldForestOwnerTypeOrganizationDescription": "Når skogeier er for eksempel et firma",
    "fieldForestOwnerTypePrivateDescription": "Når skogeier er en privatperson",
    "fieldForestOwnerTypeSameieDescription": "Når skogeier er to eller flere personer eller juridiske enheter, som eier noe sammen. Gjelder ikke ektefeller, de må registreres som privat skogeier",
    "shareholderFormSubmittedLabel": "Søknadsskjema er sendt inn",
    "shareholderFormSubmittedDescription": "Velg denne hvis søknadsskjemaet for opprettelse av andelseierskap allerede er levert",
    "limitedAccess": "Begrenset tilgang",
    "noSwAccessInfo": "Du kan registrere skogeieren, men ikke opprette andelseierskap. Hvis skogeieren skal bli andelseier vil dette bli fulgt opp av Viken Skog etter fullført registrering."
  },
  "step2": {
    "title": "Leverandørnummer",
    "description": "Legg til eller opprett leverandørnummer",
    "descriptionWithSuppliers": "Vi fant disse leverandørnumrene knyttet til organisasjonsnummeret",
    "hasDeliveredTimber": {
      "label": "Har skogeieren levert tømmer tidligere?",
      "description": "Gjelder all tidligere tømmerleveranse, ikke bare til {{tenantName}}"
    },
    "alert": {
      "noSuppliers": "Ingen leverandørnummer funnet",
      "noSuppliersDescription": "Fant ingen leverandørnummer knyttet til ditt organisasjonsnummer {{orgNumber}}",
      "hasSuppliers": "Eksisterende leverandørnummer",
      "hasSuppliersDescription": "Følgende leverandørnummer er registrert for denne organisasjonen:",
      "manualSupplierNumber": "En saksbehandler vil finne leverandørnummer manuelt etter at registreringen er fullført",
      "manualSupplierNumberDescription": "Skogeiere som har levert tømmer før har som regel et eksisterende leverandørnummer. En saksbehandler vil finne det manuelt etter at registreringen er fullført.\n\nHvis det ikke finnes et aktuelt nummer, oppretter saksbehandleren et nytt og knytter det til hovednummeret.",
      "supplierNumber": "Vi vil opprette leverandørnummer når registreringen er fullført"
    }
  },
  "shareholderDialog": {
    "title": "Vil du fortsette til registrering av andelseierskap?",
    "description": "Hvis du ikke ønsker å gjøre dette nå vil en ansvarlig hos Viken Skog bli varslet på e-post og følge opp videre.",
    "continue": "Fortsett til andelseierskap",
    "notNow": "Ikke nå"
  },
  "step1": {
    "title": "Legg til informasjon om skogeier",
    "description": "Fyll inn informasjon om skogeier",
    "fieldFirstNameLabel": "Fornavn",
    "fieldFirstNameDescription": "Eksempel: Ola",
    "fieldLastNameLabel": "Etternavn",
    "fieldLastNameDescription": "Eksempel: Nordmann",
    "fieldBirthDateLabel": "Fødselsdato",
    "fieldBirthDateDescription": "Eksempel: dd.mm.åååå",
    "fieldPersonalNumberLabel": "Personnummer (<i>valgfritt</i>)",
    "fieldPersonalNumberPersonTypeLabel": "Personnummer (<i>valgfritt</i>)",
    "fieldPersonalPersonTypeNumberDescription": "Eksempel: 20100",
    "fieldPersonalNumberDescription": "Eksempel: 20100",
    "fieldNameLabel": "Fult navn",
    "fieldSameieNameLabel": "Sameiets navn",
    "fieldOrganizationNameDescription": "Eksempel: Tre Virke AS",
    "fieldOrganizationNumberLabel": "Organisasjonsnummer",
    "fieldOrganizationNumberDescription": "Skriv inn organisasjonsnummeret (9 siffer)",
    "fieldNameDescription": "Eksempel: Ola Nordmann",
    "fieldCoLabel": "C/O (valgfritt)",
    "fieldCoDescription": "Eksempel: Kari Nordmann",
    "fieldCoHelpText": "C/O brukes hvis du mottar post via en annen person – for eksempel hvis du bor midlertidig hos noen.",
    "fieldAddressLabel": "Adresse",
    "fieldAddressDescription": "Eksempel: Tømmergata",
    "fieldHouseLabel": "Husnummer",
    "fieldHouseDescription": "Eksempel: 16C",
    "fieldPostcodeLabel": "Postnummer",
    "fieldPostcodeDescription": "Eksempel: 0123",
    "fieldCountryLabel": "Land",
    "fieldEmailLabel": "E-post",
    "fieldEmailDescription": "Eksempel: ola@nordmann.no",
    "fieldPhoneLabel": "Telefonnummer",
    "fieldPhoneDescription": "Eksempel: 91 23 45 67",
    "fieldPlaceLabel": "Sted",
    "fieldPlaceDescription": "Eksempel: Oslo",
    "fieldContactPersonFirstNameLabel": "Fornavn",
    "fieldContactPersonFirstNameDescription": "Eksempel: Kari",
    "fieldContactPersonLastNameLabel": "Etternavn",
    "fieldContactPersonLastNameDescription": "Eksempel: Nordmann",
    "fieldContactPreferenceLabel": "Kontaktpreferanser",
    "fieldContactPreferenceDescription": "Hvordan ønsker skogeier å bli kontaktet?",
    "contactPreferencesTitle": "Kontaktpreferanser",
    "contactPreferencesDescription": "Fyll inn hvordan post og faktura skal sendes",
    "contactPreferencesGeneralTitle": "Generell informasjon",
    "contactPreferencesGeneralDescription": "Velg hvordan skogeier ønsker å motta informasjonsskriv, nyhetsbrev osv.",
    "contactPreferencesDocumentsTitle": "Dokumenter og avregninger",
    "contactPreferencesDocumentsDescription": "Velg hvordan skogeier ønsker å motta avtaledokumenter, årsoppgaver osv.",
    "contactPreferencesDocumentsDescriptionSBSkog": "Velg hvor skogeier ønsker å motta dokumenter og avregninger",
    "contactPreferencesInvoiceTitle": "Faktura",
    "contactPreferencesInvoiceDescription": "Velg hvordan skogeier ønsker å motta faktura.",
    "fieldOrganizationTypeLabel": "Type organisasjon",
    "fieldOrganizationTypePrivate": "Sameie",
    "fieldOrganizationTypeOther": "Annet",
    "fieldOrganizationTypeDescription": "Velg en type organisasjon som skal registreres",
    "contactPreferenceEmail": "E-post",
    "contactPreferencePhone": "SMS",
    "contactPreferencePost": "Post (brev)",
    "coOwnerSectionTitle": "Representant",
    "coOwnerSectionDescription": "Fyll inn hvem som skal være representant på vegne av skogeieren",
    "coOwnerModalTitle": "Representant",
    "coOwnerModalDescription": "Fyll inn hvem som skal være representant og kontaktes på vegne av skogeieren",
    "coOwnerModalFirstNameLabel": "Fornavn",
    "coOwnerModalFirstNameDescription": "Eksempel: Ola",
    "coOwnerModalLastNameLabel": "Etternavn",
    "coOwnerModalLastNameDescription": "Eksempel: Nordmann",
    "coOwnerModalPersonalNumberLabel": "Personnummer (<i>valgfritt</i>)",
    "coOwnerModalPersonalNumberDescription": "Eksempel: 20100",
    "coOwnerModalEmailLabel": "E-post",
    "coOwnerModalEmailLabelDescription": "Eksempel: ola@nordmann.no",
    "coOwnerModalPhoneLabel": "Telefonnummer",
    "coOwnerModalPhoneDescription": "Eksempel: 91 23 45 67",
    "coOwnerModalHasOwnAddressLabel": "Medeier har egen adresse",
    "coOwnerModalHasOwnAddressDescription": "Huk av denne hvis medeier har annen adresse enn skogeier",
    "coOwnerModalAddressLabel": "Adresse",
    "coOwnerModalAddressDescription": "Eksempel: Tømmergata",
    "coOwnerModalHouseNumberLabel": "Husnummer",
    "coOwnerModalHouseNumberDescription": "Eksempel: 16C",
    "coOwnerModalCityLabel": "By",
    "coOwnerModalCityDescription": "Eksempel: Oslo",
    "coOwnerModalPostcodeLabel": "Postnummer",
    "coOwnerModalPostcodeDescription": "Eksempel: 0123",
    "coOwnerModalDeleteButton": "Slett representant",
    "coOwnerModalSaveButton": "Lagre endringer",
    "contactPersonModalTitle": "Kontaktperson (C/O)",
    "contactPersonModalDescription": "Fyll inn personlig informasjon om kontaktperson (C/O) du vil legge til",
    "contactPersonModalDeleteButton": "Slett kontaktperson (C/O)",
    "contactPersonSectionTitle": "Kontaktpersoner (C/O)",
    "contactPersonOrganizationSectionTitle": "Kontaktperson (C/O)",
    "contactPersonSectionDescription": "Har skogeier en kontaktperson (C/O), legg det til her",
    "contactPersonOrganizationSectionDescription": "Fyll inn hvem som skal kontaktes på vegne av skogeieren",
    "addRepresentantButton": "Legg til representant",
    "representantValidationError": "Vennligst åpne representant-skjemaet og kontroller at alle påkrevde felt er fylt ut"
  },
  "step3": {
    "title": "Eiendommer",
    "description": "Legg til en eller flere eiendommer",
    "kommune": "Kommune",
    "gardsnummer": "Gårdsnummer",
    "bruksnummer": "Bruksnummer",
    "addProperty": "Legg til eiendom",
    "siblingCheckRetry": "Prøv igjen",
    "siblingCheckFailedTitle": "Kunne ikke kontrollere eierskap for alle eiendommer",
    "siblingCheckFailedDescription": "Eierskap kunne ikke kontrolleres for {{properties}}. Disse eiendommene er ikke lagt til. Du kan fortsette med de øvrige eiendommene.",
    "siblingCooperativeCheckFailedTitle": "Kunne ikke kontrollere andelsforhold for alle eiendommer",
    "siblingCooperativeCheckFailedDescription": "Andelsforhold kunne ikke kontrolleres for {{properties}}. Disse eiendommene er ikke lagt til. Du kan fortsette med de øvrige eiendommene.",
    "propertyRequired": "Legg til minst én eiendom for å fortsette",
    "ownershipMustBeDocumentedBadge": "Eierskap/fullmakt må dokumenteres",
    "ownershipDialogTitle": "{{owner}} er ikke registrert eier av {{mainNumber}}",
    "ownershipDialogRegisteredOwner": "{{registeredOwner}} står registrert som eier på eiendommen med gård- og bruksnummer {{farm}}/{{property}}.",
    "ownershipDialogInfo": "{{registeredOwner}} står registrert som eier på eiendommen.\n\nDu kan likevel legge til eiendommen, men den vil bli merket som “uverifisert” og eierskap eller fullmakt må dokumenteres senere før det kan inngås avtaler på eiendommen.",
    "ownershipDialogRemove": "Avbryt",
    "ownershipDialogKeepUnverified": "Legg til som uverifisert eiendom",
    "noResultsDialogTitle": "Eiendom ikke funnet",
    "noResultsDialogDescription": "Vi fant ikke eiendommen. Kontroller at du har skrevet riktig gårds- og bruksnummer, og at eiendommen er registrert som en landbrukseiendom.",
    "propertyNotFoundDialogTitle": "Eiendom ikke funnet",
    "propertyNotFoundDialogDescription": "Vi fant ikke eiendommen. Kontroller at du har skrevet riktig gårds- og bruksnummer, og at eiendommen er registrert som en landbrukseiendom.",
    "duplicatePropertyDialogTitle": "Eiendom {{mainNumber}} er allerede lagt til",
    "duplicatePropertyDialogDescription": "Denne eiendommen er allerede registrert i listen over eiendommer. Du kan ikke legge til samme eiendom flere ganger.",
    "multipleOwnersDialogTitle": "Eiendommen har mer enn to eiere",
    "multipleOwnersDialogDescription": "{{ownerNames}} er registrert som eiere av {{mainNumber}}.\n\n Eiendommen må registreres som et sameie, med mindre {{forestOwnerName}} har eksklusiv bruksrett på eiendommen",
    "multipleOwnersMarriedOption": "Eierne er gift/samboere",
    "multipleOwnersExclusiveUseOption": "Skogeier har enerett til eiendommen",
    "allOwners": "Alle eiere",
    "allOwnersDescription": "Oversikt over alle registrerte eiere",
    "multipleOwnersJointOwnershipOption": "Dette er et sameie",
    "multipleOwnersContinue": "Fortsett",
    "multipleOwnersAddProperty": "Behold som uverifisert eiendom",
    "twoOwnersDialogTitle": "Eiendommen har to eiere",
    "twoOwnersDialogDescription": "{{ownerNames}} er registrert som eiere av {{mainNumber}}. \n\nEiendommen må registreres som et sameie, med mindre eiere er ektefeller/partnere eller det foreligger tinglyst avtale om eksklusiv bruksrett.",
    "twoOwnersOwnershipTypeLabel": "Velg type eiendomsforhold",
    "twoOwnersOwnershipTypePlaceholder": "Velg",
    "twoOwnersOwnershipTypeSearchPlaceholder": "Søk etter type eiendomsforhold...",
    "twoOwnersOwnershipTypeNoResults": "Ingen resultater funnet",
    "twoOwnersMarriedOption": "Partnere/ gift",
    "twoOwnersExclusiveUseOption": "Eksklusiv bruksrett",
    "twoOwnersJointOwnershipOption": "Sameie",
    "twoOwnersAddProperty": "Legg til eiendom",
    "twoOwnersJointOwnershipWarningTitle": "Eiendommen kan ikke legges til",
    "twoOwnersJointOwnershipWarningDescription": "Hvis eiendommen er et sameie, må sameiet registreres som skogeier for å kunne inngå avtaler.",
    "jointOwnershipDialogTitle": "Sameie må registreres",
    "jointOwnershipDialogDescription": "Denne eiendommen har {{ownerCount}} eiere og må registreres som et sameie. Sameiet må registreres som en egen skogeier.",
    "jointOwnershipDialogClose": "Lukk",
    "verificationStatusVerified": "Verifisert eierskap",
    "verificationStatusUnverified": "Eierskap må dokumenteres",
    "verificationStatusMultipleOwners": "Flere eiere - krever dokumentasjon",
    "verificationStatusJointOwnership": "Sameie - krever dokumentasjon",
    "registeredOwner": "Eier av gårds- og bruksnummeret",
    "registeredOwners": "Eier av gårds- og bruksnummeret",
    "groupHeaderLabel": "Hovednummer {{mainNumber}} ({{municipalityName}})",
    "supplierNumberLabel": "Leverandørnummer",
    "processingProperty": "Behandler...",
    "table": {
      "property": "Eiendom",
      "area": "Areal",
      "shares": "Andeler"
    },
    "badges": {
      "ownershipSharedWithPartner": "Eierskap deles med partner",
      "exclusiveUsageRights": "Eksklusiv bruksrett"
    },
    "supplierSelectionDialogTitle": "Velg leverandørnummer du ønsker å knytte til {{mainNumber}}",
    "supplierSelectionDialogDescription": "Eiendommen har flere leverandørnumre. Ett må velges, men kan endres senere.",
    "supplierSelectionDialogLabel": "Leverandørnummer",
    "supplierSelectionDialogCancel": "Avbryt",
    "supplierSelectionDialogSave": "Lagre",
    "supplierNumberAutoAssigned": "Leverandørnummer {{number}} er automatisk tilordnet",
    "supplierNumberToBeCreated": "Opprettes ved fullføring",
    "supplierNumberManualProcessing": "Sendes til manuell behandling",
    "supplierNumberToBeCreatedAfterVerification": "Opprettes etter verifisering",
    "editSupplierNumber": "Endre leverandørnummer",
    "removePropertyDialogTitle": "Er du sikker på at du vil fjerne eiendom {{propertyNumber}}?",
    "removePropertyDialogDescription": "Du må legge til eiendommen på nytt dersom du angrer.",
    "removePropertyDialogConfirm": "Fjern eiendom",
    "removePropertyDialogCancel": "Avbryt",
    "shareholderModalTitle": "Bekreft fullmakt på eiendom {{property}}",
    "shareholderModalDescription": "Sjekk at alle registrerte eiere av eiendommen har signert på at {{representant}} har fullmakt til å representere sameiet overfor Viken Skog",
    "shareholderModalOwnersTitle": "Registrerte eiere av eiendom {{property}}:",
    "shareholderModalChooseOption": "Velg et alternativ",
    "shareholderModalConfirmedOption": "Fullmakt er signert av alle registrerte eiere",
    "shareholderModalConfirmedDescription": "Eiendom legges til i eiendommer med fullmakt",
    "shareholderModalNotConfirmedOption": "Fullmakten samsvarer ikke med registrerte eiere av eiendommen",
    "shareholderModalNotConfirmedDescription": "Last opp ny fullmakt eller dokumentasjon på endret eierskap senere",
    "shareholderModalAddProperty": "Legg til eiendom",
    "shareholderModalKeepUnverified": "Behold som uverifisert eiendom",
    "shareholderModalCancel": "Avbryt",
    "ownershipConflictDialogTitle": "Eiendom allerede eid",
    "ownershipConflictDialogDescription": "Eiendommen {{mainNumber}} er allerede eid av en annen skogeier. Vil du tvinge overføring av eierskap?",
    "ownershipConflictDialogForce": "Tving eierskap",
    "ownershipConflictDialogCancel": "Avbryt"
  },
  "step4": {
    "title": "Oppsummering",
    "description": "Sjekk at informasjonene stemmer før du lagrer",
    "fictionalOrgNumberToBeCreated": "Fiktivt org.nummer opprettes ved fullføring",
    "supplierNumberManualProcessing": "Krever manuell behandling"
  },
  "confirmResetSteps": {
    "title": "Endring av for- og etternavn, fødselsdato eller organisasjonsnummer krever ny utfylling av steg 2 og 3",
    "description": "Denne handlingen kan ikke angres. Du må fylle ut steg 2 Leverandørnummer og steg 3 Eiendom på nytt dersom du angrer.",
    "actionLabel": "Endre likevell",
    "cancelLabel": "Behold nåværende opplysninger"
  },
  "fileUploaderDialog": {
    "documentTypeRequired": "Dokumentasjonstype må velges først",
    "uploadRequired": "Du må laste opp en fil eller velge å laste den opp senere."
  }
}
